import * as cookie from "./cookie";
var setSession = function setSession(session) {
  Object.keys(session).forEach(function (key) {
    cookie.addCookie(key, session[key], '/', 0);
  });
};
var getSession = function getSession() {
  return {
    login: cookie.getCookie('login'),
    token: cookie.getCookie('token'),
    userCode: cookie.getCookie('userCode'),
    userName: cookie.getCookie('userName'),
    sidebarStatus: cookie.getCookie('sidebarStatus'),
    currentStationName: cookie.getCookie('currentStationName'),
    currentStationCode: cookie.getCookie('currentStationCode'),
    currentSiteType: cookie.getCookie('currentSiteType')
  };
};
var updateSession = function updateSession(session) {
  Object.keys(session).forEach(function (key) {
    cookie.addCookie(key, session[key], '/', 0);
  });
};
var removeSession = function removeSession() {
  cookie.delCookie('login', '/');
  cookie.delCookie('token', '/');
  cookie.delCookie('userCode', '/');
  cookie.delCookie('userName', '/');
  cookie.delCookie('sidebarStatus', '/');
  cookie.delCookie('currentStationName', '/');
  cookie.delCookie('currentStationCode', '/');
  cookie.delCookie('currentSiteType', '/');
};
var getToken = function getToken() {
  return getSession().token;
};
var isAuthenticated = function isAuthenticated() {
  return !!getSession().token;
};
var signout = function signout(history) {
  var logout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var applicationCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'admin';
  // 从session里面取出code
  var code = window.sessionStorage.getItem('applicationCode');
  removeSession();
  window.location.href = "".concat(process.env.SSO_URL, "/?url=").concat(encodeURIComponent(window.location.href), "&redirect=true&logout=").concat(logout, "&applicationCode=").concat(code || applicationCode);
};
var GLOBAL_ROLES = [];
var setRoles = function setRoles(roles) {
  GLOBAL_ROLES = roles;
  // window.localStorage.setItem('roles', JSON.stringify(roles))
};

var getRoles = function getRoles() {
  // const rolesJSON = window.localStorage.getItem('roles')
  // return JSON.parse(rolesJSON || '[]')
  return GLOBAL_ROLES;
};
export { signout, setSession, getSession, getToken, removeSession, isAuthenticated, updateSession, setRoles, getRoles };